<template>
    <div class="subscription-notification" :class="{ show: notification.show }">
        <div class="subscription-notification__content" :class="contentClass" v-show="notification.show">
            <p class="notification-text">
                <span class="notification-title">{{ notification.title }}</span>
                <span class="notification-subtitle" v-if="notification.subtitle">{{ notification.subtitle }}</span>
            </p>
            <button class="notification-remove" @click="remove" :aria-label="`Remove notification`">
                <svg width="20" height="20" viewBox="0 0 10 10" fill="none">
                    <path d="M1 1L9 9M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Notification',
    props: {
        notification: {
            type: Object,
            required: true,
            default: () => ({
                show: false,
                type: 'general',
                title: '',
                subtitle: '',
            }),
        },
    },
    computed: {
        contentClass() {
            if (this.notification.type === 'error') {
                return 'subscription-notification__content--error';
            } else if (this.notification.type === 'general') {
                return 'subscription-notification__content--general';
            }
            return '';
        },
    },
    methods: {
        remove() {
            this.$emit('remove');
        },
    },
};
</script>

<style scoped type="scss">
.subscription-notification {
    scroll-margin-top: 60px;
    z-index: 1000;
    width: 100%;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease-in-out;
}

.subscription-notification.show {
    opacity: 1;
    visibility: visible;
}

.subscription-notification__content {
    background-color: #4b8c37;
    color: white;
    padding: 20px;
    text-align: center;
    font-family: 'Oswald', sans-serif;
    font-weight: 400;
    font-size: 27px;
    line-height: 33px;
    position: relative;
    display: flex;
}

.subscription-notification__content--error {
    background-color: #d32f2f;
}

.subscription-notification__content--general {
    background-color: #000;
}

.subscription-notification .notification-text {
    margin: 0;
    flex-grow: 1;
}

.subscription-notification .notification-title {
    text-transform: uppercase;
    display: block;
    margin-bottom: 5px;
}

.subscription-notification .notification-subtitle {
    font-weight: 300;
    font-size: 22px;
    line-height: 28px;
}

.subscription-notification .notification-remove {
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    transition: color 0.2s ease;
}

@media (max-width: 768px) {
    .subscription-notification {
        top: 10px;
        left: 16px;
        right: 16px;
        width: auto;
        transform: none;
        max-width: none;
    }

    .subscription-notification__content {
        padding: 16px;
        font-size: 20px;
        line-height: 26px;
    }

    .subscription-notification__content .notification-subtitle {
        font-size: 16px;
        line-height: 22px;
    }

    .subscription-notification .notification-remove svg {
        width: 75%;
    }
}
</style>